<template>
  <div>
    <!-- <back-header :header="'我的收藏'"></back-header> -->
    <div class="collection">
      <div class="card" v-for="(collction, index) in collectionList" :key="index" @click="toDetail(collction)">
        <div class="card-detail">
          <div class="quiz-title"><span class="quiz-title-text">{{collction.quizName}}</span></div>
          <div class="quiz-name"><span class="quiz-name-text">{{collction.quizIntro}}</span></div>
          <div class="quiz-foot">
            <span>
              <p class="sale-price">￥{{collction.h5SalePrice}}</p>
              <s>￥{{collction.quizPrice}}</s>
              <p class="user-count">{{collction.userCount}}已测</p>
            </span>
          </div>
        </div>
        <div class="img-box">
          <img class="quiz-img" :src="publicUrl + collction.quizThumbnail">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Button from "@m/vant/Button";
  // import BackHeader from "../../../components/BackHeader.vue"
  import * as api from "@p/api";
  import publicUrl from "@p/public";
  export default {
    mixins: [Button],
    data() {
      return {
        publicUrl,
        collectionList: []
      }
    },
    created() {
      this.getCollections();
    },
    components: {
      // 'back-header': BackHeader
    },
    methods: {
      async getCollections() {
        var params = {
          ids: localStorage.getItem('collection')
        }
        var collections = await api.requestApiByPost('getQuizListByIds', params);
        if (collections.code === 0) {
          this.collectionList = collections.data;
        }
      },
      toDetail(item) {
        this.$router.push({
          path: "/detail",
          query: {
            quizId: item.id
          }
        });
      }
    }
  }
</script>

<style lang="less" scoped>
  .collection {
    float: left;
    width: 100vw;
    padding-bottom: 70px;
    overflow: scroll;
  }

  .card {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    transition: 0.3s;
    width: 79vw;
    margin-top: 3.5vh;
    margin-left: 5vw;
    border-radius: 3px;
    border: #aeaeae 1px;
    padding: 3vw 3vh;
    background-color: #ffffff;
    float: left;

    .card-detail {
      width: 59vw;
      height: 20vw;
      float: left;

      .quiz-title {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 4vw;
        height: 7vw;
        font-weight: bold;
        .quiz-title-text {
          height: 6vw;
          line-height: 1.8;
        }
      }

      .quiz-name {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 3vw;
        color: #aeaeae;
        height: 8vw;

        .quiz-name-text {
          height: 6vw;
          line-height: 2;
        }
      }

      .quiz-foot {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 3vw;
        color: #aeaeae;
        height: 5vw;
        line-height: 1.5;
      }
    }

    .img-box {
      width: 20vw;
      float: left;

      .quiz-img {
        height: 20vw;
        width: 20vw;
        border-radius: 7px;
      }
    }
  }

  .sale-price {
    color: #F9D64B
  }

  .user-count {
    float: right;
  }

  p {
    display: inline;
    margin-right: 2vw;
  }
</style>
